import { IBaseIconProps } from "./IBaseIconProps";

export const CreditCardIcon = ({ color = "#fff" }: IBaseIconProps) => {
  return (
    <svg
      fill={color}
      width="800px"
      height="800px"
      viewBox="0 0 32 32"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M28 4.75h-24c-1.794 0.002-3.248 1.456-3.25 3.25v16c0.002 1.794 1.456 3.248 3.25 3.25h24c1.794-0.001 3.249-1.456 3.25-3.25v-16c-0.002-1.794-1.456-3.248-3.25-3.25h-0zM28.75 24c-0 0.414-0.336 0.75-0.75 0.75h-24c-0.414-0-0.75-0.336-0.75-0.75v-16c0.001-0.414 0.336-0.749 0.75-0.75h24c0.414 0 0.75 0.336 0.75 0.75v0zM10 20.75h-4c-0.69 0-1.25 0.56-1.25 1.25s0.56 1.25 1.25 1.25v0h4c0.69 0 1.25-0.56 1.25-1.25s-0.56-1.25-1.25-1.25v0zM20 20.75h-6c-0.69 0-1.25 0.56-1.25 1.25s0.56 1.25 1.25 1.25v0h6c0.69 0 1.25-0.56 1.25-1.25s-0.56-1.25-1.25-1.25v0zM24 16.75h-18c-0.69 0-1.25 0.56-1.25 1.25s0.56 1.25 1.25 1.25v0h18c0.69 0 1.25-0.56 1.25-1.25s-0.56-1.25-1.25-1.25v0zM26 8.75h-6c-0.69 0-1.25 0.56-1.25 1.25v4c0 0.69 0.56 1.25 1.25 1.25h6c0.69-0 1.25-0.56 1.25-1.25v-4c-0-0.69-0.56-1.25-1.25-1.25h-0zM24.75 12.75h-3.5v-1.5h3.5z"></path>
    </svg>
  );
};
